/** Shared timeline presets for the customer and ops dashboards. */
const pad = (n) => String(n).padStart(2, "0");
export const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export const PRESETS = [
  { id: "today", label: "Today" },
  { id: "yesterday", label: "Yesterday" },
  { id: "7d", label: "Last 7 days" },
  { id: "30d", label: "Last 30 days" },
  { id: "month", label: "This month" },
  { id: "all", label: "All time" },
  { id: "custom", label: "Custom range" },
];

/** Returns {from, to} as YYYY-MM-DD (inclusive), or {} for all time. */
export const rangeFor = (preset, custom = {}) => {
  const now = new Date();
  const today = startOfDay(now);
  const shift = (days) => iso(new Date(today.getTime() - days * 86400000));
  switch (preset) {
    case "today":
      return { from: iso(today), to: iso(today) };
    case "yesterday":
      return { from: shift(1), to: shift(1) };
    case "7d":
      return { from: shift(6), to: iso(today) };
    case "30d":
      return { from: shift(29), to: iso(today) };
    case "month":
      return { from: iso(new Date(now.getFullYear(), now.getMonth(), 1)), to: iso(today) };
    case "custom":
      return custom.from && custom.to ? { from: custom.from, to: custom.to } : { from: shift(29), to: iso(today) };
    default:
      return {};
  }
};

export const rangeQuery = (preset, custom) => {
  const { from, to } = rangeFor(preset, custom);
  return from && to ? `from=${from}&to=${to}` : "range=all";
};

export const labelFor = (preset, custom = {}) => {
  if (preset === "custom" && custom.from && custom.to) return `${custom.from} → ${custom.to}`;
  return PRESETS.find((p) => p.id === preset)?.label || "All time";
};
